package com.pincer.core.rules

import com.pincer.core.model.tree.Candidate

class OrRule(rules: Set<Rule>): CompoundRule(rules) {
    override fun score(candidate: Candidate): Float = scoreEach(candidate).last()
}
